import { render, staticRenderFns } from "./returnGoodsDetails.vue?vue&type=template&id=4973a240&scoped=true&"
import script from "./returnGoodsDetails.vue?vue&type=script&lang=js&"
export * from "./returnGoodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./returnGoodsDetails.vue?vue&type=style&index=0&id=4973a240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4973a240",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4973a240')) {
      api.createRecord('4973a240', component.options)
    } else {
      api.reload('4973a240', component.options)
    }
    module.hot.accept("./returnGoodsDetails.vue?vue&type=template&id=4973a240&scoped=true&", function () {
      api.rerender('4973a240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/returnGoodsDetails.vue"
export default component.exports